const axios = require("axios");

export const getResellers = () => {
  return axios.get("/api/resellers");
};
